/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
import React from 'react'
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../context/AuthContext'

// Logout component. Ask confirmation to leave and destroy cookies
function Logout() {
  const { logout } = useAuth()

  const logoutAction = async () => {
    if (confirm('Está seguro que desea salir?')) logout()
  }

  return (
    <button type='submit' onClick={logoutAction}>
      <LogoutIcon className='text-indigo-500 text-2xl ml-4' title='Salir' />
    </button>
  )
}

export default Logout
